import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Plus(): React.ReactElement {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.62551 4.37424V-0.000244141H4.37551V4.37424H0V5.62424H4.37551V9.99976H5.62551V5.62424H10V4.37424H5.62551Z" />
    </svg>
  );
}
